import Logger from 'src/core/utils/Logger'

export const decodeJwtPayload = <T = unknown>(token: string): T | null => {
  try {
    const parts = token.split('.')
    if (parts.length !== 3) {
      throw new Error('Invalid JWT format')
    }

    const base64Url = parts[1]
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')

    const paddedBase64 = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=')

    const jsonPayload = atob(paddedBase64)
    return JSON.parse(jsonPayload)
  } catch (error) {
    Logger.error('Failed to decode JWT payload:', error)
    return null
  }
}
